export default __webpack_public_path__ + "static/media/Vector.14cd063b.svg";